import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';
import * as _ from 'lodash';
import classNames from 'classnames';

class DetailView extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.editAccount = this.editAccount.bind(this);
    this.cancelUpdate = this.cancelUpdate.bind(this);
    const {profile} = props;
    this.state = {
      editable: false,
      profile: _.merge(DetailView.getDefaultProfile(), profile),
      errors: props.errors || {},
    };
  }

  static getDefaultProfile() {
    return {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      subscription: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const result = {};
    result.errors = nextProps.errors;

    if (!prevState.editable) {
      result.profile = _.merge(DetailView.getDefaultProfile(), nextProps.profile);
    }
    return result;
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    const {profile, errors} = this.state;
    profile[name] = value;
    errors[name] = null;
    this.setState({
      profile: profile,
      errors: errors,
    });
  }

  getDataUser() {
    let {profile} = this.state;
    return {
      ...profile,
    };
  }

  handleSubmit(event) {
    event.preventDefault();

    this.props.action({
      ...this.getDataUser(),
    }).then(() => {
      this.setState({
        editable: false,
      });
    });
  }

  editAccount() {
    this.props.onEdit();
    this.setState({
      editable: true,
    });
  }

  cancelUpdate() {
    this.props.onCancel();
    this.setState({
      editable: false,
    });
  }

  render() {
    const {errors, profile} = this.state;
    const {t, inProgress} = this.props;
    const {editable} = this.state;
    return (
        <form onSubmit={this.handleSubmit} className="form">
          <div className="profile__row">
            <div className="profile__column">
              <div className="form__row">
                <label className="form__label">{t('first_name')}</label>
                <input
                  required={true}
                  disabled={!editable}
                  name='first_name'
                  type="text"
                  placeholder={t('first_name')}
                  className="input input--block"
                  value={profile.first_name}
                  onChange={this.handleChange}
                  autoComplete='off'
                />
              </div>
              {errors.first_name &&
              <div className="form__row form__row--invalid">
                <p>{t('error_first_name')}</p>
              </div>
              }
              <div className="form__row">
                <label className="form__label">{t('last_name')}</label>
                <input
                  required={true}
                  disabled={!editable}
                  name='last_name'
                  type="text"
                  placeholder={t('last_name')}
                  className="input input--block"
                  value={profile.last_name}
                  onChange={this.handleChange}
                  autoComplete='off'
                />
              </div>
            </div>
            {errors.last_name &&
            <div className="form__row form__row--invalid">
              <p>{t('error_last_name')}</p>
            </div>
            }
            <div className="profile__column">
              <div className="form__row">
                <label className="form__label">{t('phone_number')}</label>
                <input
                  required={true}
                  disabled={!editable}
                  name='phone'
                  type="tel"
                  placeholder={t('phone_number')}
                  className="input input--block"
                  value={profile.phone}
                  onChange={this.handleChange}
                  autoComplete='off'
                />
              </div>
              {errors.phone &&
              <div className="form__row form__row--invalid">
                <p>{errors.phone}</p>
              </div>
              }
              <div className="form__row">
                <label className="form__label">{t('email')}</label>
                <input
                  required={true}
                  disabled={!editable}
                  name='email'
                  autoComplete='off'
                  type="email"
                  placeholder={t('email')}
                  className="input input--block"
                  value={profile.email}
                  onChange={this.handleChange}
                />
              </div>
              {errors.email &&
              <div className="form__row form__row--invalid">
                <p>{t('email_wrong')}</p>
              </div>
              }
            </div>
          </div>

          <div className="form__row">
            <label className={classNames('checkbox', {'checkbox--disabled': !editable})}>
              <input
                disabled={!editable}
                name="subscription"
                type="checkbox"
                className="checkbox__input"
                checked={profile.subscription}
                onChange={this.handleChange}
                autoComplete='off'
              />
              <span className="checkbox__text">
                {t('confirm_subscription')}
              </span>
            </label>
          </div>
          <div className="form__row">
            <div className={!editable ? 'profile__one-buttons' : 'profile__double-buttons'}>
              {!editable ?
                <button className="form__button" type="button" onClick={this.editAccount}>{t(
                  'edit')}</button>
                :
                <div className='profile__double-buttons profile__double-buttons--centered'>
                  <button className="form__button" type="button" onClick={this.cancelUpdate}>{t(
                    'cancel')}</button>
                  <button
                    className="form__button"
                    type="submit"
                    disabled={inProgress}>
                    {t('update')}
                  </button>
                </div>
              }
            </div>
          </div>
        </form>
    );
  }
}

DetailView.propTypes = {
  profile: PropTypes.object.isRequired,
  errors: PropTypes.object,
  action: PropTypes.func.isRequired,
  onEdit: PropTypes.func,
  onCancel: PropTypes.func,
  inProgress: PropTypes.bool,
};

export default translate('translations')(DetailView);



// WEBPACK FOOTER //
// ./src/components/Customer/Profile/DetailView.js